module.exports = __webpack_public_path__ + "static/media/alchemist.7228250b.jpg";